import classnames from "classnames";
import * as React from 'react';
import style from './FieldError.scss';

type Props = React.PropsWithChildren<{
  className?: string
}>;

const FieldError: React.FunctionComponent<Props> = (props) => {
  return (
    <div className={classnames(style.container, props.className)}>
      {props.children}
    </div>
  );
};

export default FieldError;
